import axios from 'axios';
import { PROVIDERS_URL,USER_PHONE_VALIDATIONS,USER_PHONE_VERIFICATION } from '../../../../config';

export function submitProviderInfo(data) {
	return axios.post(PROVIDERS_URL, data);
}

export function verificationPhoneNumber(data) {
	return axios.post(USER_PHONE_VERIFICATION, data);
}

export function userPhoneValidations(data) {
	return axios.post(USER_PHONE_VALIDATIONS, data);
}